import { render, staticRenderFns } from "./OverlapSidebar.vue?vue&type=template&id=763cb9a9&scoped=true"
import script from "./OverlapSidebar.vue?vue&type=script&lang=js"
export * from "./OverlapSidebar.vue?vue&type=script&lang=js"
import style0 from "./OverlapSidebar.vue?vue&type=style&index=0&id=763cb9a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763cb9a9",
  null
  
)

export default component.exports